import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import "../../../styles/main.css"
import { I18nextProvider } from "react-i18next"
import { Provider } from "react-redux"
import { store } from "../../../app"
import RootLayout from "../../../shared/Layouts/RootLayout"

const mount = () => {
  const node = document.getElementById("bundle-sync-service")
  if (!node) return

  const props = JSON.parse(node.getAttribute("data-props") || "{}")

  const i18n = window.i18n
  if (!i18n) {
    window.addEventListener("i18n:ready", mount, { once: true })
    return
  }

  if (props.locale) {
    i18n.changeLanguage(props.locale)
  }

  const root = createRoot(node)
  root.render(
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <RootLayout themeName={props?.themeName ?? "default"}>
          <App {...props} />
        </RootLayout>
      </I18nextProvider>
    </Provider>
  )
}

document.addEventListener("DOMContentLoaded", mount)
